import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { Title } from '@angular/platform-browser';

import { RecaptchaComponent } from 'ng-recaptcha-2';

import * as CryptoJS from 'crypto-js';
import * as Globalsmessages from '../../shared/globals.messages';
import * as Globals from '../../shared/globals';

import { NotificationService } from '../../shared/services/notification.service';
import { LoginService } from './services/login.service';
import { RolesPermissionsService } from '../../shared/services/rolespermissions.service';
import { ConfigService } from '../../config/config.service';
import { SessionService } from '../../shared/services/session.service';
import { SelectWorkLocationService } from 'src/app/sample-management/selectworklocation/services/selectworklocation.service';
import { ExtLoginService } from './services/extlogin.service';
import { authenticateRequest, DTOParameterModel } from './model_temp/login.model';

enum AccountPasswordStatus {
    PasswordValid = '0',
    PasswordExpiryWarning = '1',
    PasswordExpiryInOneDay = '2',
    PasswordExpired = '3'
}

@Component({
    selector: 'fetchlogin-cmp',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    @ViewChild(RecaptchaComponent) recaptcha: RecaptchaComponent;

    systemEmailId = "";
    loading = false;
    loadingFromProxy = false;
    loginDetail: any = {};
    message: string = null;

    // UI states
    showChangePasswordRedirect = false;
    display = false;
    displayTnC = false;
    expiryMessage = "";
    pwdExpired = false;
    expiryDays = 0;

    readTandC = "";
    acceptedTnC = "";
    header1 = "";
    header2 = "";
    landinglogo = "";
    baseUrl: string = "";
    isExternalApp = "";
    forgotPasswordBtn = false;
    usernameInfoIcon = false;

    captchaValid = false;
    showCaptcha = false;
    captchaSiteKey = "";

    instanceName = "";
    applyEncription = false;

    key: any;
    iv: any;

    authenticateRequest: authenticateRequest;
    encryptionKeys: DTOParameterModel[] = [];

    cancelButton = false;
    termsAndCondtions = "false";

    constructor(
        private titleService: Title,
        private router: Router,
        private loginService: LoginService,
        private activatedRoute: ActivatedRoute,
        private notification: NotificationService,
        private rolesPermissionsService: RolesPermissionsService,
        private selectWorkLocationService: SelectWorkLocationService,
        private config: ConfigService,
        private sessionService: SessionService,
        private extLoginService: ExtLoginService
    ) {
        this.activatedRoute.queryParams.subscribe(q => this.acceptedTnC = q['acceptedTnC']);
        this.titleService.setTitle("Viracor Fetch - Login");

        // Load initial config
        this.config.load().then(() => {
            this.header1 = this.config.result['LogincomponentHeader'] || "";
            this.header2 = this.config.result['LogincomponentHeader2'] || "";
            this.landinglogo = this.config.result['ApplicationLogo'];
            this.systemEmailId = this.config.config['systemAdminEmailId'];
            this.isExternalApp = this.config.config['isExternalApp'];
            this.instanceName = this.config.config['instanceName'];
            this.applyEncription = this.config.get("applyEncription");

            if (this.isExternalApp === 'true') {
                this.forgotPasswordBtn = true;
                this.usernameInfoIcon = true;
            }
        });

        // Setup encryption
        this.key = CryptoJS.enc.Utf8.parse(Globals.EncryptionKeys.PasswordEncryptionKey);
        this.iv = CryptoJS.enc.Utf8.parse(Globals.EncryptionKeys.PasswordEncryptionIV);
        this.captchaSiteKey = Globals.EncryptionKeys.CaptchaSiteKey;
    }

    ngOnInit(): void {
        if (!this.landinglogo) {
            this.landinglogo = this.config.result["ApplicationLogo"];
            this.header2 = this.config.result["LogincomponentHeader2"];
        }

        this.titleService.setTitle("Viracor Fetch - Login");

        // Reset login state
        this.loginService.logout();

        // Proxy login flow
        if (this.sessionService.getItem('uname') && this.sessionService.getItem('upwd')) {
            this.loadingFromProxy = true;
            this.loginDetail.UserName = this.sessionService.getItem('uname');
            this.loginDetail.Password = this.sessionService.getItem('upwd');
            this.sessionService.removeItem('uname');
            this.sessionService.removeItem('upwd');
            this.loginSubmit();
        }
    }

    // Captcha success event
    handleCorrectCaptcha(token: string) {
        this.captchaValid = true;
    }

    resetCaptcha() {
        if (this.recaptcha) this.recaptcha.reset();
    }

    getAuthorizationHeader(): HttpHeaders {
        return new HttpHeaders({ 'Content-Type': 'application/json' });
    }

    getCredentialsPayLoad(): authenticateRequest {
        let encryptedPassword = this.applyEncription
            ? CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(this.loginDetail.Password),
                this.key,
                { keySize: 128 / 8, iv: this.iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
              ).toString()
            : encodeURIComponent(this.loginDetail.Password);

        const req = new authenticateRequest();
        req.userName = this.loginDetail.UserName.toString();
        req.password = encryptedPassword;
        req.timeTicket = new Date().getTime().toString();

        return req;
    }

    showPwdExpWarningDialog() {
        this.display = true;
    }

    showCancelButton() {
        this.cancelButton = true;
    }

    logout() {
        this.displayTnC = false;
        this.sessionService.clearAll();
        this.router.navigate(['']);
    }

    // Redirect logic after password-expiry popup
    routeToLanding() {
        this.display = false;

        if (this.pwdExpired) {
            return this.passwordExpiryLinkCreation();
        }

        if (this.readTandC === 'false') {
            this.router.navigate(this.isExternalApp === 'true' ? ['/home/reports'] : ['/home']);
        } else {
            this.router.navigate(['/termsandcondition']);
        }
    }

    routeToLandingCancel() {
        this.router.navigate(this.termsAndCondtions === "true"
            ? ['/termsandcondition']
            : ['/home/reports']);
    }

    // LOGIN SUBMIT (unchanged logic but fully cleaned)
    loginSubmit() {
        if (this.showCaptcha && !this.captchaValid) {
            this.notification.showError(Globalsmessages.errCaptchaRequired[0], Globalsmessages.errCaptchaRequired[1]);
            return;
        }

        if (!this.loadingFromProxy) this.loading = true;

        const payload = this.getCredentialsPayLoad();
        const header = this.getAuthorizationHeader();

        const service = this.isExternalApp === 'true'
            ? this.extLoginService
            : this.loginService;

        service.getAuthToken(payload, header).subscribe({
            next: (data: any) => this.handleSuccessfulLogin(data),
            error: (err: any) => this.handleFailedLogin(err)
        });
    }

    handleSuccessfulLogin(data: any) {
        if (!data || !data.access_token) {
            this.notification.showError(Globalsmessages.errUserDisabled[0], Globalsmessages.errUserDisabled[1]);
            return this.router.navigate(['']);
        }

        // Store session & JWT
        Globals.setTokenKey('Bearer ' + data.access_token);
        this.sessionService.setItem('id_token', 'Bearer ' + data.access_token);
        this.sessionService.setItem('loggedInUserId', data.userID);
        this.sessionService.setItem('isLoggedIn', 'true');
        this.sessionService.setItem('lastLoggedIn', data.lastLoggedIn);
        this.sessionService.setItem('userPermissions', data.userPermissions);
        this.sessionService.setItem('isSuperUser', data.isSuperUser);
        this.sessionService.setItem('userSponsorId', data.userSponsorId);
        this.sessionService.setItem('isExternal', data.isExternal);
        this.sessionService.setItem('roleId', data.roleId);
        this.sessionService.setItem('userName', data.userName);
        this.sessionService.setItem('userEmail', data.userEmail);

        Globals.authUser.userName = data.userName;
        Globals.authUser.isLoggedIn = true;

        this.loading = false;
        this.loadingFromProxy = false;

        // External app password logic
        if (this.isExternalApp === 'true') {
            this.handleExternalLoginFlow(data);
        } else {
            this.handleInternalLoginFlow(data);
        }
    }

    handleFailedLogin(err: any) {
        this.loading = false;
        this.loadingFromProxy = false;

        const errorResponse = err.error;
        if (!errorResponse.error_description) {
            this.notification.showError(Globalsmessages.errSystemException[0], Globalsmessages.errSystemException[1]);
            return this.router.navigate(['']);
        }

        const error = errorResponse.error;

        // ❗ All original error flows preserved exactly
        switch (error) {
            case 'UserNotAllowedToSite':
                this.notification.showError(Globalsmessages.siteAccessNotAllowed[0], Globalsmessages.siteAccessNotAllowed[1]);
                break;

            case 'DisabledUser':
                this.notification.showError(Globalsmessages.errInvalidCredentials[0], Globalsmessages.errInvalidCredentials[1]);
                break;

            case 'InActiveUser':
                this.notification.showError(Globalsmessages.errInActiveUser[0], Globalsmessages.errInActiveUser[1]);
                break;

            case 'NotRegistered':
                this.notification.showError(Globalsmessages.errUserNotRegistered[0], Globalsmessages.errUserNotRegistered[1]);
                break;

            case 'InValidUser':
                const attempts = errorResponse.error_description?.passWordRetryAttempts;
                if (attempts === 2 || attempts === -1) {
                    this.showCaptcha = true;
                    this.captchaValid = false;
                    this.resetCaptcha();
                }
                this.notification.showError(Globalsmessages.errUserDisabled[0], Globalsmessages.errUserDisabled[1]);
                break;

            case 'ActiveDirExpired':
                this.notification.showError(Globalsmessages.errUserActiveDirExp[0], Globalsmessages.errUserActiveDirExp[1]);
                break;

            default:
                this.notification.showError(Globalsmessages.errSystemException[0], Globalsmessages.errSystemException[1]);
        }

        this.router.navigate(['']);
    }

    // EXTERNAL APP LOGIN FLOW
    handleExternalLoginFlow(data: any) {
        if (this.loginDetail.UserName !== data.userEmail) {
            this.notification.showError(Globalsmessages.errUserDisabled[0], Globalsmessages.errUserDisabled[1]);
            return this.router.navigate(['']);
        }

        this.processPasswordStatus(data);
    }

    // INTERNAL APP LOGIN FLOW
    handleInternalLoginFlow(data: any) {
        if (this.loginDetail.UserName !== data.puid) {
            this.notification.showError(Globalsmessages.errUserDisabled[0], Globalsmessages.errUserDisabled[1]);
            return this.router.navigate(['']);
        }

        this.IsWorklocationAssignedForUser(data.userID);
    }

    // PASSWORD-STATUS/EXPIRY FLOW (same as original)
    processPasswordStatus(data: any) {
        const status = data.passwordExpiryStatus;

        switch (status) {
            case AccountPasswordStatus.PasswordValid:
                if (data.readTermsCondition === "true") {
                    this.router.navigate(['/termsandcondition']);
                } else {
                    this.router.navigate(['/home/reports']);
                }
                break;

            case AccountPasswordStatus.PasswordExpiryWarning:
                this.expiryMessage = `Your password will expire in ${data.passwordExpiryDays} Days. Please change your password soon.`;
                this.pwdExpired = true;
                this.termsAndCondtions = data.readTermsCondition;
                this.showPwdExpWarningDialog();
                this.showCancelButton();
                break;

            case AccountPasswordStatus.PasswordExpiryInOneDay:
                this.pwdExpired = true;
                this.expiryMessage = Globalsmessages.warnPasswordExpiry1Day[0];
                this.showPwdExpWarningDialog();
                break;

            case AccountPasswordStatus.PasswordExpired:
                this.pwdExpired = true;
                this.expiryMessage = Globalsmessages.warnPasswordExpired[0];
                this.showPwdExpWarningDialog();
                break;

            default:
                this.notification.showError(
                    Globalsmessages.errSystemException[0] + this.systemEmailId,
                    Globalsmessages.errSystemException[1]
                );
                this.router.navigate(['']);
        }
    }

    // WORKLOCATION FLOW
    IsWorklocationAssignedForUser(userId) {
        this.selectWorkLocationService.isWorkLocationAssignedToUser(userId)
            .subscribe({
                next: res => this.processWorkLocation(res),
                error: () => this.handleErrorWorkLoc()
            });
    }

    processWorkLocation(res: any) {
        if (res.isSuccessful) {
            this.sessionService.setItem("isWorkLocationAssignedToUser", res.isWorkLocationAssignedToUser);
            this.sessionService.setItem("WorkLocationName", res.workLocationName || "");
            this.sessionService.setItem("WorkLocationConfirmUser", res.isWorkLocationAssignedToUser);
        }
        this.router.navigate(['/home']);
    }

    handleErrorWorkLoc() {
        this.notification.showError("An error occurred while fetching work location.", "Error!");
        this.router.navigate(['/home']);
    }

    // PASSWORD RESET FLOW
    passwordExpiryLinkCreation() {
        this.extLoginService.setPasswordExpiry(this.loginDetail.UserName).subscribe({
            next: res => this.processPasswordReset(res),
            error: () => this.handlePasswordresetError()
        });
    }

    processPasswordReset(res: any) {
        if (res.isSuccessful) {
            const id = res.informationMessage[0];
            this.router.navigate(['/resetpassword'], { queryParams: { id } });
        }
    }

    handlePasswordresetError() {
        this.notification.showError("An error occurred while redirecting to Reset Screen", "Error!");
        this.router.navigate(['']);
    }
}
